import { createContext, RefObject } from 'react'
import { AppBarSettings } from './AppBarSettings'

export type AppBarContextValue = {
    fabRef?: RefObject<HTMLDivElement>
    settings: AppBarSettings
}

export const AppBarContext = createContext<AppBarContextValue | undefined>(undefined)
